
define('text!modules/creatives/display/templates/details.html',[],function () { return '<div class="details check-radio-forms"></div>\n{{>footer}}';});

